import React, { Component } from 'react';
import { Radio, Button, Select } from 'antd';
import { connect } from 'react-redux';
import { PickMonthWrapper } from './style';

const { Option } = Select;

class Payment extends Component {
	state = {
		method: 'crypto',
		currency: 'btc'
	};

	renderOptions = () => {
		const { coin } = this.props;
		const List = coin.map((item) => (
			<Option value={item.value} key={item.value}>
				{item.key}
			</Option>
		));
		return List;
	};

	render() {
		const { method, currency } = this.state;
		const { onOk } = this.props;
		const style = {
			display: 'flex',
			alignItems: 'top',
			padding: '24px 0'
		};
		return (
			<PickMonthWrapper>
				<Radio.Group
					value={method}
					onChange={(v) => {
						this.setState({ method: v.target.value });
					}}
				>
					<Radio value="crypto" style={style}>
						<div className="pick-month-radio-info">
							<p>
								<b>Crytpocurrency</b>
							</p>
							{method === 'crypto' ? (
								<Select
									value={currency}
									onChange={(v) => {
										this.setState({ currency: v });
									}}
								>
									{this.renderOptions()}
								</Select>
							) : null}
						</div>
					</Radio>
					<Radio value="hollaex" style={style}>
						<div className="pick-month-radio-info">
							<p>
								<b>HollaEx Token</b>
							</p>
						</div>
					</Radio>
					<Radio value="bank" style={style}>
						<div className="pick-month-radio-info">
							<p>
								<b>Bank Wire Transfer</b>
							</p>
						</div>
					</Radio>
				</Radio.Group>
				<Button
					block
					type="primary"
					onClick={() => {
						onOk(method, currency);
					}}
				>
					Next
				</Button>
			</PickMonthWrapper>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		coin: state.coin
	};
};

export default connect(mapStateToProps)(Payment);
